export const CATCORP_ESITE = 'catcorp';
export const CATCORP_STORE_ID = '21801';
export const GENERIC_GUEST_USER_ID = '-1002';
export const CATCORP_USER_DEALER = 'CATCorp';
export const CATCORP_ESITE_IDENTIFIER = 'CATCorp';
export const CONTACT_DEALER = 'Contact Dealer';
export const CC_START_PAGE_VALUE = 'cc';
export const DEFAULT_CURRENCY = 'USD';
export const CART_ATTRIBUTE_DISPLAY_COUNT = 3;
export const ATTRIBUTE_DISPLAY_COUNT = 2;
export const PACKAGE_ERROR_COOKIE = 'packageErrorCookies';

export const RTL_LANGUAGES = ['ar', 'he'];

export const DEBOUNCE_TIME_MILLISECONDS = 300;
export const DEBOUNCE_TIME_50_MILLISECONDS = 50;
export const PRODUCT_FALLBACK_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20170508-76204-57647';

export const GENERIC_USER_EQUIPMENT_RESPONSE = {
  selectedEquipmentIndex: -1,
  myEquipmentList: null
};
export const GOOGLE_MAPS_API_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '';

export const DEFAULT_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20170508-76204-57647';

export const DEFAULT_IMAGE_2 =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250401-3e606-c4a98';

export const NO_EXACT_MATCH_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20230710-4a31c-f981b?fmt=webp',
  alt: 'DEQ_NO_EXACT_MATCH'
};

export const PRODUCT_TYPE = {
  PACKAGE_BEAN: 'PackageBean',
  PRODUCT_BEAN: 'ProductBean'
};

export const PAGE_BREAKPOINTS = {
  XXL: 1232,
  XL: 1200,
  LG: 992,
  BLOCKS_LG: 960,
  MD: 768,
  SM: 576,
  BLOCKS_SM: 560,
  XS: 400
};

export const LONG_DATE_FORMAT_WITH_TIME = 'MMMM dd, yyyy, h:mm a';
export const MEDIUM_DATE_FORMAT = 'MMMM dd, yyyy';
export const ESTIMATED_DELIVERY_DATE_PARSE_FORMAT = 'yyyy-M-dd H:m:s.SSS';
export const SHORT_DATE_FORMAT = 'MM/dd/yyyy';
export const MMM_DD_DATE_FORMAT = 'MMM dd';
export const YYYY_MM_DD_DATE_FORMAT = 'yyyy-MM-dd';

export const QUERY_FETCH_STATUS = {
  ERROR: 'error',
  PENDING: 'pending',
  SUCCESS: 'success'
};
export const NUMBER_REGEX = '[0-9]+$';
export const ALPHA_NUMERIC_REGEX = '^[a-zA-Z0-9]+$';

export const SAVED_LIST = 'Saved List';
export const CORE_TRACKING = 'CoreList';
export const PENDING_QUOTES = 'Pending Quotes';
export const QUOTES_SEARCH = 'quoteSearch';
export const GENERAL = 'General';
export const DEFAULT_QO_ROW_VALUES = {
  quantity: '',
  itemNumber: '',
  assetId: '',
  serialNumber: '',
  lineItemNote: '',
  customerPartNumber: '',
  customerItemNumber: '',
  page: GENERAL,
  id: '',
  referenceId: ''
};

export const YES = 'Yes';
export const NO = 'No';

// This text is not translated because is the product name (based on AB#540398)
export const SIS_TITLE = 'Service Information System (SIS)';

export const FILE_FORMATS = {
  csv: 'csv',
  xls: 'xls',
  xlsx: 'xlsx',
  pdf: 'pdf'
};

export const FILE_EXTENSIONS_FORMATS = {
  CSV: '.CSV',
  XLS: '.XLS',
  XLSX: '.XLSX',
  PDF: '.PDF'
};

export const UNIT_OF_MEASURE_COOKIE = 'uom';

export const UOM = {
  metric: 'metric',
  us: 'us',
  c62: 'C62'
};

export const UOM_COOKIE = {
  us: 'INH',
  metric: 'MMT'
};

export const ONETRUST = {
  FUNCTIONAL_COOKIES: 'C0003',
  FUNCTIONAL_COOKIES_ACCEPTED: 'C0003%3A1',
  FUNCTIONAL_COOKIES_REJECTED: 'C0003%3A0',
  TARGET_COOKIES: 'C0004',
  TARGET_COOKIES_ACCEPTED: 'C0004%3A1',
  TARGET_COOKIES_REJECTED: 'C0004%3A0',
  GROUP_UPDATED_EVENT_LISTENER: 'OneTrustGroupsUpdated',
  OPT_CONSENT_COOKIE: 'OptanonConsent'
};
export const Image_Banner =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240523-f2388-8c97d';

export const FREIGHT_COST_CHARGED_AT_INVOICE = 'I';

export const QUOTE_STATUS_TYPE = {
  WAITING_FOR_APPROVAL: 'W',
  QUOTE_STATUS_X: 'X'
};
export const EXP_DATE_QUOTE_STATUS = ['NEW', 'E'];
export const ORDER_TYPE = {
  STANDARD: 'STD',
  STOCK: 'STK'
};

export enum LIST_TYPES {
  PRIVATE = 'private',
  SHARED = 'shared',
  PUBLIC = 'public',
  DEALER = 'dealer'
}

export const EMPTY_MESSAGE = {
  type: '',
  title: '',
  body: ''
};

export const RECENTLY_VIEWED_PAGE_SOURCES = {
  HOME: 'home',
  PERSONAL_INFORMATION: 'personalInformation',
  CONTROL_CENTER: 'controlCenter'
};

export const ERROR_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240523-b8387-22a51';

export const KOREAN_CURRENCY = 'WON';
export const KOREAN_CURRENCY_SYMBOL = '원';
export const RECENTLY_VIEWED_PAGE = 'PCC recently viewed products Page';
export const SEARCH_PAGE = 'PCC Search Results Page';
export const CATEGORY_SERVICE_ERROR = 'CATEGORY_SERVICE_ERROR';

export const CLP_PAGE_ESPOT_PLACEHOLDER_2 = 'CLP_PAGE_ESPOT_PLACEHOLDER_2';
export const PLP_ESPOT_NAME = 'CATSAS_SUBCLP_ESPOT';
export const BUY_AGAIN_PAGE = 'PCC Buy Again Page';
export const UOMINCH = 'UOMINCH';
export const UOMMETRIC = 'UOMMETRIC';

export const RESPONSE_FILTER = {
  ALL: 'all',
  PARTS: 'parts',
  DIAGRAM: 'diagrams'
} as const;

export const DEFAULT_PAGE_SIZE = 12;
export const PAGE_SIZE_OPTIONS = [12, 24, 48, 96];
export const DEFAULT_PAGE = 1;

export const SEARCH_TYPE_RECENTLY_VIEWED = 'recentlyViewed';
export const SEARCH_TYPE_BUY_AGAIN = 'buyAgain';

export const FEEDBACK_TYPES = {
  ERROR: 'error',
  WARNING: 'warning'
} as const;

export const DROPBOX = 'dropBox';

export const SVG_MIME_TYPE = 'image/svg+xml';

export const DIY_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20200817-c0f2b-914aa?$Type2$${IMAGE_PRESETS}',
  alt: 'DIY_IMAGES'
};

export const DIY_IMAGE_SIZE = {
  width: 84,
  height: 52
};

export const SSO_CONFIG_BOX_SIZE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20170508-76204-57647',
  alt: 'No Image',
  width: 450,
  height: 450
};
